// Sites hidden from the Fert Paperwork "new session" site picker.
// Add an ADO reference when extending this list.
export const NEW_SESSION_HIDDEN_SITE_IDS = new Set<string>([
  'ea9c3eae-4e95-ee11-82cf-0022482fd8ca', // IACD - IA Commercial Dairy (29397)
]);

export function filterNewSessionSites<T extends { id: string }>(
  sites: readonly T[] | undefined | null,
): T[] {
  if (!sites?.length) return [];
  return sites.filter(
    (s) => !NEW_SESSION_HIDDEN_SITE_IDS.has(s.id.toLowerCase()),
  );
}
